import { BaseService } from './base.service';
import { User } from '../models/user.models';
import { SearchTrainingPayload } from '../models/service.models';

export default class AssignedTrainingsService extends BaseService {
  public async getAssignedTrainings(payload: SearchTrainingPayload) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const params = new URLSearchParams({
      start: payload.start,
      end: payload.end,
    }).toString();
    return this.axios.get(`${this.backendUrl}/athlete/trainings?${params}`, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getAssignedTraining(id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.get(`${this.backendUrl}/athlete/training/${id}`, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getAssignedTrainingForCoach(trainingId: string, memberId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.get(`${this.backendUrl}/coach/training/${trainingId}/member/${memberId}`, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async incompleteAssignedTraining(id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.delete(`${this.backendUrl}/athlete/training/${id}`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async completeAssignedTraining(id: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.post(
      `${this.backendUrl}/athlete/training/${id}`,
      {},
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async linkEquipmentToTraining(trainingId: string, payload: { equipmentId: number }) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.post(`${this.backendUrl}/v2/training/${trainingId}/link-equipment`, payload, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async updateEffortRating(trainingId: string, payload: { effortRating: number }) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.post(`${this.backendUrl}/v2/training/${trainingId}/effort-rating`, payload, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async updateRSVPStatus(trainingId: string, rsvpStatus: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(
      `${this.backendUrl}/v2/training/${trainingId}/rsvp`,
      { rsvpStatus },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async updateAttendanceStatus(trainingId: string, memberId: number, attended: boolean | null) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(
      `${this.backendUrl}/training/${trainingId}/member/${memberId}/attended-status`,
      { attended },
      {
        headers: {
          'x-access-token': user.token,
          'Content-Type': 'application/json',
          'Measurement-System': user.measurementSystem,
        },
      }
    );
  }

  public async logDataToAssignedTraining(id: string, distanceComplete: string[], durationComplete: string[]) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.post(
      `${this.backendUrl}/athlete/training/${id}/log`,
      {
        distanceComplete,
        durationComplete,
      },
      {
        headers: {
          'x-access-token': user.token,
          'Measurement-System': user.measurementSystem,
        },
      }
    );
  }
}
